<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <v-container id="document_signature_customization_root" fluid>
    <implicit-authorization-modal
      :key="implicitAuthorizationModalKey"
      :signature-guid="implicitGuid"
      :request-loading-dialog-showed=" ImplicitAuthorizationModalVisible"
    ></implicit-authorization-modal>
    <!-- header -->
    <v-row class="mb-6 px-6" justify="center" align="center">
      <v-btn
        id="back_button"
        class="elevation-0 pl-0 pr-3"
        color="black--text grey lighten-2"
        @click="back"
      >
        <v-icon
          class="ma-0 pa-0"
          color="grey darken-3"
        >
          mdi-chevron-left
        </v-icon>
        {{ $t('main.back') }}
      </v-btn>
      <v-col cols="7">
        <span class="text-h5">
          {{ chainContainer?.batch?.name }}</span>
      </v-col>

      <v-col class="d-flex flex-row justify-end">
        <v-btn
          v-if="!useExternalSignature"
          id="signature_confirmation_sign_btn"
          class="mx-4 px-4"
          color="success"
          :disabled="!isFormValid"
          :loading="isUploading"
          @click="handleSignClick"
        >
          <v-icon class="mr-1 ml-0">mdi-draw-pen</v-icon>
          {{ $t("main.sign") }}
        </v-btn>
        <v-btn
          color="error"
          outlined
          class="px-2"
          :loading="isUploading"
          @click="showDeclineModal($event)"
        >
          <v-icon
            class="mr-1 ml-0"
          >
            mdi-close-circle-outline
          </v-icon>
          {{ $t('dataTable.content.action.decline') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      align="stretch"
      align-content="space-between"
    >
      <v-col md="6" sm="12" align="start">
        <!-- SIGNATURE + CRED  CONFIG-->
        <v-card v-show="pdfRendered">
          <v-container class="d-flex flex-column">
            <v-form ref="form" v-model="formValid" @input="handleFormValidityChange">
              <v-row>
                <v-col>
                  <p v-show="showBlueWarning" class="BlueWarning">{{ $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}</p>
                  <p class="BlueWarning">{{ $t('documentSignatureCustomization.content.signature.asicSign.visibleSignatureExplainer') }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-show="showCredentialSelector">
                  <v-divider role="presentation"></v-divider>
                  <v-select
                    v-if="credentialsWithCentralKeyToo.length > 0"
                    id="signature_customization_credential_select"
                    v-model="selectedCredential"
                    class="mx-3 mt-5"
                    :items="credentialsWithCentralKeyTooComputed"
                    :item-text="getCredentialItemText"
                    :return-object="true"
                    :label="
                      $t(
                        'documentSignatureCustomization.content.signature.selectSigningCredential'
                      ) + `*`
                    "
                    :rules="showCredentialSelector ? [rules.requiredSimple] : []"
                  >
                  </v-select>
                  <p v-show="showBlueWarning" class="BlueWarning">
                    {{
                      $t(
                        "documentSignatureCustomization.warning.someCredendetialHaveProblem"
                      )
                    }}
                  </p>
                </v-col>
              </v-row>
              <v-card class="mt-6 pa-4">
                <v-list shaped>
                  <v-list-item-group v-model="currentDoc" mandatory @change="downloadDocument(currentDoc)">
                    <v-list-item v-for="doc in containedDocuments" :key="doc.id" :value="doc">
                      <v-list-item-content>
                        <v-list-item-title v-text="doc.fileName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon>
                          mdi-chevron-right
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-form>
          </v-container>
        </v-card>
      </v-col>
      <!-- visibleSignatureComponent -->
      <v-col
        cols="6"
        md="6"
        sm="12"
        align="center"
        style="position: relative;"
      >
        <v-overlay
          :absolute="true"
          :value="isUploading"
        >
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
        </v-overlay>
        <visibleSignature
          ref="visibleSignature"
          :doc-data="documentBase64"
          @pdfLoaded="pdfLoaded"
          @passwordSpecified="handlePasswordSpecified"
        />
      </v-col>
    </v-row>
    <!-- authorizationModal -->
    <v-row justify="center">
      <v-dialog v-model="authorizationModal" persistent max-width="500">
        <v-card id="explicit_auth_modal">
          <v-card-title>
            <span class="headline">{{ $t('documentSignatureCustomization.modal.authorization.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="authorizationModalForm" v-model="authorizationModalFormValid" @submit.prevent>
              <v-text-field
                id="explicit_authmodal_textfield"
                ref="passwordField"
                v-model="expAuthPwd.pwd"
                tabindex="1"
                :append-icon="expAuthPwd.showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('documentSignatureCustomization.modal.authorization.content.keyPassword') + `*`"
                :type="expAuthPwd.showPwd ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :rules="[rules.required, rules.passwordMustBeLongerThan, rules.onlyNumber]"
                @click:append="expAuthPwd.showPwd = !expAuthPwd.showPwd"
                @keydown.enter="signDoc()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text tabindex="3" @click="authorizationModal = false">{{ $t('main.cancel') }}</v-btn>
            <v-btn
              id="explicit_authmodal_signbtn"
              color="success"
              tabindex="2"
              :disabled="!authorizationModalFormValid"
              :loading="authorizationModalBtnLoading"
              @click="signDoc()"
            >
              {{ $t('documentSignatureCustomization.modal.authorization.content.button.sign') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noCredentialWarningVisible" persistent width="auto" max-width="700">
        <v-card id="no_credential_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedCredential.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.noActivatedCredential.description') }}
            </div>
            <v-btn
              id="no_credential_warning_ok"
              style="text-align: center;"
              color="primary"
              to="/credentials"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.noActivatedCredential.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noDeviceForImplicitCredentialWarningVisible" persistent max-width="550">
        <v-card id="no_device_warning" class="pa-6">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedDevice.title') }}
          </v-card-title>

          <v-card-text style="text-align: center">
            <v-container>
              <v-row justify="start">
                <div>
                  {{ $t('signatureProfiles.error.noActivatedDevice.description') }}
                </div>
                <div class="pt-6">
                  <v-btn
                    id="no_device_warning_ok"
                    color="primary"
                    to="/user/profile/"
                    class=" mb-0"
                  >
                    <v-icon class="mr-1">mdi-cellphone-key</v-icon>
                    {{ $t('signatureProfiles.error.noActivatedDevice.button') }}
                  </v-btn>
                </div>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <decline-reason-modal
        :visible="declineReasonVisible"
        :signature-id="getUserSignatureId(chainContainer)"
        :current-signature-id="getCurrentSignatureId(chainContainer)"
        @declined="back"
      ></decline-reason-modal>
    </v-row>
  </v-container>
</template>

<script>

import documents from '@/services/api/documents'
import rssp from '@/services/api/rsspUtil.js'
import signatureChains from '@/services/api/signatureChains'
import signatureProfiles from '@/services/api/signatureProfiles'
import signatures from '@/services/api/signatures'
import credentialRefs from '@/services/api/credentialRefs'
import csc from '@/services/api/csc'
import evro from '@/services/api/evro'
import CommonError from '@/views/CommonError'
import RdssError from '@/views/RdssError'
import CredentialAuthMode from '../CredentialAuthMode'
import SignatureChainType from '../chains/SignatureChainType'
import memberRole from '@/views/signature/chains/memberRole'
// import errorHandler from '../errorHandler'
import VisibleSignature from '@/components/VisibleSignature'
import { showConfirmationMenu, showRequestLoadingDialog, showToastError, showToastSuccess } from '@/event-bus'
import seal from '@/services/api/seal.js'
import { UserManager } from 'oidc-client-ts'
import { v4 as uuidv4 } from 'uuid'
import DeclineReasonModal from '../DeclineReasonModal'
import ImplicitAuthorizationModal from '../ImplicitAuthorizationModal'
import SignatureChainStatus from './SignatureChainStatus.js'
import users from '@/services/api/users'

export default {
  name: 'AsicSignatureCustomization',

  components: {
    VisibleSignature,
    ImplicitAuthorizationModal,
    DeclineReasonModal
  },

  data() {
    return {
      providers: [],
      formValid: true,
      evroEnabled: this.$store.state.remoteConfig.evroEnabled
        ? this.$store.state.remoteConfig.evroEnabled
        : false,
      documentBase64: null,
      document: {},
      pdfRendered: false,
      useDifferentCredential: false,
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      rsspRemoteConf: null,
      externalSignaturesEnabled: this.$store.state.remoteConfig.externalSignaturesEnabled
        ? this.$store.state.remoteConfig.externalSignaturesEnabled
        : false,
      useExternalSignature: false,
      externalSignatureIdsCorrect: false,
      signatureProfiles: [],
      useVisibleSignature: false,
      useSignatureProfile: false,
      selectedSignatureProfile: {
        credentialId: ''
      },
      // signatureProfile: {},
      signatureImg: null,
      signatureTextSize: 14,
      activatedCredentials: [],
      credentialRefs: [],
      credentialsEvro: [],
      credentialsAlfa: [],
      myCredentials: [],
      idToken: null,
      credentialsWithCentralKeyToo: [],
      encryptionDatas: [],
      selectedCredential: {},
      switchSignatureChainType: false,
      draftRecipients: [{ userId: null }],
      authorizationModalFormValid: false,
      authorizationModal: false,
      authorizationModalBtnLoading: false,
      // implicitAuthorizationModal
      implicitAuthorizationModalKey: 0,
      implicitGuid: '',
      devicesListTotalItems: 0,
      ImplicitAuthorizationModalVisible: false,
      showBlueWarning: false,
      noCredentialWarningVisible: false,
      noDeviceForCredentialWarningVisible: false,
      noDeviceForImplicitCredentialWarningVisible: false,
      // centralKeyId: 'central_key_id',
      user: null,
      authorizationTimeoutMilis: this.$store.state.remoteConfig
        ? this.$store.state.remoteConfig.authorizationTimeoutSecs * 1000
        : null,
      evroTrustAuthorizationTimeoutMilis: this.$store.state.remoteConfig
        ? this.$store.state.remoteConfig.evroAuthorizationTimeoutSecs * 1000
        : 60 * 1000,
      showSignatureModal: false,
      centralKeyId: -1,
      originalSignatureProfiles: [],
      expAuthPwd: {
        pwd: null,
        showPwd: false
      },
      uploadedExternalFile: null,
      uploadedExternalFileName: null,
      credentialAliveError: null,
      passwordMinCharacters: 6,

      rules: {
        requiredSimple: (v) => !!v || this.$t('validation.form.requiredField'),
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        passwordMustBeLongerThan: v => (v && v.length >= this.passwordMinCharacters) || this.$t('validation.form.passwordMustBeLongerThan', { min: this.passwordMinCharacters }),
        onlyNumber: v => (/^[0-9]+$/.test(v)) || this.$t('validation.form.onlyNumbers'),
        // credentialAlive: (v) => (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === this.selectedSignatureProfile.credentialId) || !!this.selectedCredential.id))) || this.$t('validation.form.credentialIsDead')
        /* credentialAlive: (v) => {
          if (this.sealEnabled) {
            // profil, nem másik jog használata
            if (!this.useDifferentCredential && this.selectedSignatureProfile.useSeal) {
              return this.sealActivated || this.$t('validation.form.centralKeyIsNotActivated')
            }
          } else {
            return (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === this.selectedSignatureProfile.credentialId) || !!this.selectedCredential.id))) || this.$t('validation.form.credentialIsDead')
          }
        } */
        credentialAlive: (v) => {
          this.credentialAliveError = ''

          if (!this.useSignatureProfile) return true

          const isEvroCred = !!(
            this.selectedCredential && this.selectedCredential.isEvro
          )
          const isAlfaCred =
            this.isAlfaTrust ||
            (!!this.selectedSignatureProfile?.alfaRefId && !this.useDifferentCredential)

          const isCredRef = !!(
            this.selectedCredential && this.selectedCredential.provider
          )

          const searchingForCredId = !this.useDifferentCredential
            ? Number(this.selectedSignatureProfile?.credentialId ?? NaN)
            : Number(this.selectedCredential?.id ?? NaN)

          const foundCred =
            Number.isFinite(searchingForCredId) &&
            this.activatedCredentials.some((c) => Number(c.id) === searchingForCredId)

          const existActvatedCred = !!this.selectedCredential && foundCred

          if (this.sealActivated) {
            if (
              this.useSignatureProfile &&
              !this.useDifferentCredential &&
              this.selectedSignatureProfile.useSeal
            ) {
              const res =
                this.sealActivated || this.$t('validation.form.centralKeyIsNotActivated')
              this.credentialAliveError = typeof res === 'boolean' ? '' : res
              return res
            }

            if (this.useSignatureProfile) {
              const ok =
                (!this.useDifferentCredential && existActvatedCred) ||
                this.useDifferentCredential ||
                isCredRef ||
                isEvroCred ||
                isAlfaCred
              const res = ok || this.$t('validation.form.credentialIsDead')
              this.credentialAliveError = typeof res === 'boolean' ? '' : res
              return res
            }

            return true
          }

          const ok =
            (!this.useDifferentCredential && existActvatedCred) ||
            this.useDifferentCredential ||
            isCredRef ||
            isEvroCred ||
            isAlfaCred
          const res = ok || this.$t('validation.form.credentialIsDead')
          this.credentialAliveError = typeof res === 'boolean' ? '' : res
          return res
        }
      },

      isUploading: true,

      // decline reasoning:
      declineReasonVisible: false,
      // asic
      containedDocuments: [],
      currentDoc: {}

    }
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser
    },

    isFormValid() {
      const isSigner = this.hasRoleInternal(memberRole.SIGNER.toLowerCase())
      if (!isSigner) {
        return false
      }

      if (
        this.sealActivated &&
        !this.useSignatureProfile &&
        (!this.selectedCredential || !this.selectedCredential.id)
      ) {
        return false
      }
      if (
        !this.useSignatureProfile &&
        this.useVisibleSignature
      ) {
        return false
      }
      // console.log('isFormValid this.selectedCredential', this.selectedCredential)

      const selectedCredIsImplicit =
        this.selectedCredential && this.isImplicitCredential
      const implicitValid =
        !selectedCredIsImplicit ||
        (!selectedCredIsImplicit.provider || (selectedCredIsImplicit && this.devicesActiveTotalItems > 0))

      const formValidRes = this.formValid
      // console.log('isFormValid formValidRes', formValidRes)
      const res = formValidRes && implicitValid
      // console.log('isFormValid', res)

      return res
    },

    sealActivated() {
      return this.sealStatus.enabled && this.sealStatus.activated
    },

    sealEnabled() {
      return this.sealStatus.enabled
    },
    isVerificationEnabled() {
      return !!this.$store.state.remoteConfig.regulaEnabled
    },
    showCredentialSelector() {
      return (
        !this.useVisibleSignature ||
        (this.useVisibleSignature && !this.useSignatureProfile) ||
        (this.useVisibleSignature &&
          this.useSignatureProfile &&
          this.useDifferentCredential)
      )
    },
    chainContainer() {
      return this.$store.state.currentChain
    },

    credentialsWithCentralKeyTooComputed() {
      return this.credentialsWithCentralKeyToo.map((item, index) => {
        /* if (this.sealActivated) {
          const centralKeyDisabled =
            (this.sealActivated && !this.useVisibleSignature) ||
            (this.useDifferentCredential &&
              this.useSignatureProfile &&
              this.selectedSignatureProfile &&
              this.selectedSignatureProfile.useSeal)

          if (index === 0 && centralKeyDisabled) {
            return {
              ...item,
              disabled: true
            }
          }
          return item
        } else {
          return item
        } */
        return item
      })
    },
    isExplicitCredential() {
      return this.selectedCredential && (this.selectedCredential.authMode === CredentialAuthMode.EXPLICIT)
    },

    isImplicitCredential() {
      return this.selectedCredential && (this.selectedCredential.authMode === CredentialAuthMode.IMPLICIT)
    },

    isOAUTH2CODECredential() {
      return this.selectedCredential && (this.selectedCredential.authMode === 'OAUTH2CODE')
    },

    isCredentialUnknownAuthMode() {
      return this.selectedCredential && (!this.selectedCredential.authMode)
    },
    isAlfaTrust() {
      return this.selectedCredential && !!(this.selectedCredential.isAlfa)
    },
    isSealSignMode() {
      const resp = !!(this.sealActivated && ((this.activatedCredentials.length === 0 && this.credentialRefs.length === 0 && this.credentialsEvro.length === 0) ||
        (this.useSignatureProfile && this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal && !this.useDifferentCredential) ||
        (this.selectedCredential && this.selectedCredential.id && this.selectedCredential.id === this.centralKeyId)))
      return resp
    }
  },

  watch: {
    selectedSignatureProfile(val, oldVal) {
      this.selectedSignatureProfileImplementation(val, oldVal)
    },
    async selectedCredential(val) {
      if (val && val.provider) {
        // const credInfo = await this.getCredentialInfosWithCSC()
      }
      if (this.selectedCredential && this.selectedCredential.id === undefined) {
        this.selectedCredential = null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.checkFormValidity()
        }
      })
    },
    async useDifferentCredential(val) {
      if (!val) {
        if (!this.useSignatureProfile) {
          this.selectedCredential = {}
        } else if (this.selectedSignatureProfile) {
          if (this.selectedSignatureProfile.credentialRefId) {
            this.selectedCredential = this.findCredentialByRefId(
              parseInt(this.selectedSignatureProfile.credentialRefId)
            )
            const credInfo = this.getCredentialInfosWithCSC()

            // console.log('credref credentialsInfo', credInfo)
          } else if (this.selectedSignatureProfile.evroRefId) {
            this.selectedCredential = this.findCredentialByEvroRefId(
              parseInt(this.selectedSignatureProfile.evroRefId)
            )
          } else {
            this.selectedCredential = this.findCredentialById(
              parseInt(this.selectedSignatureProfile.credentialId)
            )
          }
        }
        if (
          this.sealActivated &&
          this.selectedSignatureProfile &&
          this.selectedSignatureProfile.useSeal
        ) {
          // this.selectedCredential.id = this.centralKeyId
          this.selectedCredential = this.findCredentialById(-1)
        }
      } else {
        this.selectedCredential = undefined
      }

      // this.$refs.form.resetValidation()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.checkFormValidity()
        }
      })
    }
  },
  async mounted() {
    if (!this.chainContainer) {
      this.back()
      return
    }
    await this.unpackContainer()
    await this.getSignatureProfiles()
    this.downloadDocument(this.containedDocuments[0])

    this.providers = await credentialRefs.getExternalProviders('web')

    this.sealStatus = await seal.getSealStatus()
    if (this.sealActivated) {
      this.selectedCredential.id = this.centralKeyId
    }
    this.user = await users.getMyUser()

    await this.listMyActivatedCredentials()
    await this.listImportedCredentials()

    this.credentialsWithCentralKeyToo = [
      ...this.activatedCredentials,
      ...this.credentialRefs,
      ...this.credentialsEvro
    ]

    if (this.sealActivated) {
      this.credentialsWithCentralKeyToo.unshift({
        id: -1,
        description: this.$t(
          'documentSignatureCustomization.content.signature.centralKey'
        )
      })
      /* if (this.credentialsWithCentralKeyToo.length === 1) {
         this.useVisibleSignature = true
       } */
    }

    await this.handleWarning()
  },
  destroyed() {
    this.$store.commit('removeCurrentChain')
  },

  methods: {
    async handleSignClick() {
      if (this.selectedCredential?.provider) {
        if (!Array.isArray(this.providers) || this.providers.length === 0) {
          try {
            this.providers = await credentialRefs.getExternalProviders('web')
          } catch (e) {}
        }
        if (!this.selectedCredential.idToken || !this.selectedCredential.authMode) {
          const info = await this.getCredentialInfosWithCSC()

          if (!info) return
        }
      }

      const isDirect = !!(
        this.isSealSignMode ||
        this.isImplicitCredential ||
        this.isOAUTH2CODECredential ||
        this.isAlfaTrust ||
        this.selectedCredential?.isEvro ||
        (this.selectedCredential?.provider && !this.isExplicitCredential)
      )
      // console.log('isDirect', isDirect)

      if (isDirect) {
        this.signDoc()
      } else {
        this.showAuthorizationModal()
      }
    },
    async selectedSignatureProfileImplementation(val, oldVal) {
      if (!val) {
        this.selectedCredential = {}
        return
      }

      if (val?.id !== oldVal?.id) {
        if (!val?.savedSignatureFieldParameters) {
          val.savedSignatureFieldParameters = {
            originX: 0,
            originY: 0
          }
        }
      }

      if (this.predefinedSignatureParams) {
        const { originX, originY, width, height, page } = this.$route.query
        val.savedSignatureFieldParameters = {
          originX: parseFloat(originX),
          originY: parseFloat(originY),
          width: width ? parseFloat(width) : undefined,
          height: height ? parseFloat(height) : undefined,
          page: parseInt(page)
        }
      }
      if (val.credentialRefId || val.evroRefId || val.credentialId || val.alfaRefId) {
        if (this.sealEnabled && val.useSeal) {
          if (!this.selectedCredential) {
            this.selectedCredential = {}
          }
          if (val.credentialRefId) {
            this.selectedCredential.id = parseInt(val.credentialRefId)
          } else if (val.evroRefId) {
            this.selectedCredential.id = parseInt(val.evroRefId)
            this.selectedCredential.isEvro = true
          }
          if (val.alfaRefId) {
            this.selectedCredential.id = parseInt(val.alfaRefId)
            this.selectedCredential.isAlfa = true
          }
          // console.log('central key selected', this.selectedCredential)
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.checkFormValidity()
            }
          })
        } else {
          if (val.credentialRefId) {
            this.selectedCredential = this.findCredentialByRefId(
              parseInt(val.credentialRefId)
            )
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(val.credentialRefId)
            }
          } else if (val.evroRefId) {
            this.selectedCredential = this.findCredentialByEvroRefId(
              parseInt(val.evroRefId)
            )
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(val.evroRefId)
              this.selectedCredential.isEvro = true
            }
          } else if (val.alfaRefId) {
            this.selectedCredential = this.credentialsAlfa.find(
              (cred) => cred.id === val.alfaRefId
            )

            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(val.alfaRefId)
              this.selectedCredential.isAlfa = true
            }
          } else {
            this.selectedCredential = this.findCredentialById(parseInt(val.credentialId))
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
            }
          }
          if (!this.selectedCredential) {
          }

          this.$nextTick(() => {
            if (this.$refs.form) {
              this.checkFormValidity()
            }
          })
        }
      } else {
        if (!this.sealEnabled) {
          // console.log('no credential id in profile')
        }
        // console.log('no id in profile')
        this.selectedCredential = {}
        if (
          this.useSignatureProfile &&
          this.selectedSignatureProfile.useSeal &&
          this.sealActivated
        ) {
          // this.selectedCredential.id = this.centralKeyId
          this.selectedCredential = this.findCredentialById(-1)
        }
        // this.selectedCredential.id = this.centralKeyId
        this.$refs.form.resetValidation()
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.checkFormValidity()
          }
        })
      }

      if (
        this.useVisibleSignature &&
        this.useSignatureProfile &&
        !this.selectedSignatureProfile.sourceImageDataUrl
      ) {
        // console.log('calling getVisibleSignature for id', this.selectedSignatureProfile.id)
        signatures
          .getVisibleSignature(this.selectedSignatureProfile.id)
          .then((visResp) => {
            // console.log('visResp', visResp)
            this.selectedSignatureProfile.sourceImageDataUrl = visResp.data.imageDataUrl
            // console.log('profile after visResp', this.selectedSignatureProfile)
            this.$nextTick(() => {
              const visibleSignatureComponent = this.$refs.visibleSignature
              visibleSignatureComponent.updateSignatureProfile(
                this.selectedSignatureProfile
              )
            })
          })
      } else {
        // console.log('profile have sourceImageDataUrl, not calling visResp')
      }
      // console.debug('Signature profile selected this.selectedCredential',this.selectedCredential)
    },
    async getCredentialIdFromRef(credentialRefId) {
      const ref = await credentialRefs.getCredentialRef(credentialRefId)
      return ref.credentialId
    },
    async unpackContainer() {
      try {
        const batch = await documents.getBatch(this.chainContainer.batch.id)
        if (batch) {
          this.containedDocuments = await Promise.all(batch.documents.map(async d => documents.getDocument(d.id)))
        } else {
          console.error('batch is empty for id', this.chainContainer.batch.id)
        }
      } catch (error) {
        console.error(error)
      }
    },
    handlePasswordSpecified(password) {
      this.document.password = password
    },
    async downloadDocument(doc) {
      this.isUploading = true
      try {
        if (!doc.blob) {
          const blob = await documents.downloadDocument(doc.id)
          doc.blob = blob
        }
        this.document = doc
        const base64 = await this.blobToBase64(doc.blob)

        const visibleSignatureComponent = this.$refs.visibleSignature
        if ((doc.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (doc.security === 'ENCRYPTED_WITH_USER_PASSWORD')) {
          visibleSignatureComponent.updateEncryptionStatus(true)
          visibleSignatureComponent.setPassword(doc.password)
        } else {
          visibleSignatureComponent.updateEncryptionStatus(false)
          visibleSignatureComponent.setPassword(null)
        }

        this.documentBase64 = base64.split(',')[1]
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        // this.isUploading = false
      }
    },

    blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },

    async getSignatureProfiles() {
      try {
        this.signatureProfiles = await signatureProfiles.getSignatureProfiles()
        this.originalSignatureProfiles = [...this.signatureProfiles]

        this.signatureProfiles.forEach(profile => {
          delete profile.textParams
          profile.sourceImageDataUrl = profile.renderedImageDataUrl
        })
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async listMyActivatedCredentials() {
      try {
        const resp = await rssp.listMyActivatedCredentials()

        const haveInactiveCredential = this.activatedCredentials.filter(x => x.authMode === 'IMPLICIT').length
        resp.content = resp.content.filter(cred => ((cred.keyPurpose === 'ASYMMETRIC_SIGN') && (cred.certChain.length > 0)))
        this.activatedCredentials = resp.content
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async listImportedCredentials() {
      try {
        const pageRequestImported = {
          'page-num': 1,
          'page-size': 50,
          'sort-field': 'user.name',
          'sort-order': 'desc'
        }

        const pageImported = await credentialRefs.listCredentialRefs(
          this.user.id,
          null,
          pageRequestImported
        )

        this.credentialRefs = pageImported.content

        if (this.evroEnabled) {
          const pageEvroImported = await evro.listEvroRefs(
            this.user.id,
            null,
            pageRequestImported
          )
          pageEvroImported.content = pageEvroImported.content.map((item) => {
            return {
              ...item,
              isEvro: true
            }
          })
          this.credentialsEvro = pageEvroImported.content
          // console.log('listImportedCredentials this.credentialsEvro', this.credentialsEvro)
        }

        this.haveImportedcontent =
          pageImported.content.length > 0 ||
          this.credentialsEvro.length > 0
        // console.log('listImportedCredentials this.haveImportedcontent', this.haveImportedcontent)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async handleWarning() {
      try {
        const resp = await rssp.listMyCredentials()
        resp.content = resp.content.filter(
          (elem) => elem.keyPurpose === 'ASYMMETRIC_SIGN'
        )
        this.myCredentials = resp.content

        const devices = await rssp.listMyDevices()
        this.devicesListTotalItems = devices.total

        const credentialActivatedImplicitTotalItems = this.activatedCredentials.filter(
          (x) => x.authMode === 'IMPLICIT'
        ).length
        const credentialActivatedExplicitTotalItems = this.activatedCredentials.filter(
          (x) => x.authMode === 'EXPLICIT'
        ).length
        const credentialImplicitTotalItems = this.myCredentials.filter(
          (x) => x.authMode === 'IMPLICIT'
        ).length
        this.devicesActiveTotalItems = devices.content.filter(
          (x) => x.enabled === true
        ).length

        this.noDeviceForImplicitCredentialWarningVisible =
          !this.sealActivated &&
          credentialActivatedExplicitTotalItems === 0 &&
          this.devicesListTotalItems === 0 &&
          credentialImplicitTotalItems > 0
        // console.log('handleWarning this.activatedCredentials.length', this.activatedCredentials.length)
        this.noCredentialWarningVisible =
          !this.sealActivated &&
          !this.noDeviceForImplicitCredentialWarningVisible &&
          this.activatedCredentials.length === 0 &&
          !this.haveImportedcontent
        // console.log('handleWarning noCredentialWarningVisible', this.noCredentialWarningVisible)
        this.showBlueWarning =
          this.myCredentials.filter(
            (x) => x.status !== 'ACTIVATED' || x.certChain.length === 0
          ).length > 0 ||
          (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems === 0)
        // console.log('handleWarning showBlueWarning', this.showBlueWarning)
        if (
          credentialActivatedImplicitTotalItems > 0 &&
          this.devicesListTotalItems > 0 &&
          this.devicesActiveTotalItems === 0
        ) {
          this.showBlueWarning = true
        }
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    updatedSignatureProfile(variable) {
      this.selectedSignatureProfile = variable
    },

    updatedTextSize(variable) {
      this.signatureTextSize = variable
    },

    async updatedSignatureProfileImage(variable) {
      this.signatureImg = variable
    },

    pdfLoaded(variable) {
      this.pdfRendered = true
      this.isUploading = false

      if (
        this.sealActivated &&
        this.activatedCredentials.length === 0 &&
        this.credentialRefs.length === 0 &&
        this.credentialsEvro.length === 0 &&
        this.signatureProfiles.length === 1
      ) {
        this.useSignatureProfile = true
        this.selectedSignatureProfile = this.signatureProfiles[0]
        if (!this.selectedCredential) {
          this.selectedCredential = {}
        }
        if (
          this.selectedSignatureProfile.credentialRefId ||
          this.selectedSignatureProfile.evroRefId ||
          this.selectedSignatureProfile.credentialId
        ) {
          this.selectedCredential.id = this.selectedSignatureProfile.credentialRefId
            ? this.selectedSignatureProfile.credentialRefId
            : parseInt(this.selectedSignatureProfile.credentialId)
        }
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.checkFormValidity()
          }
        })

        const visibleSignatureComponent = this.$refs.visibleSignature
        if (!visibleSignatureComponent.isFabricControlsInited()) {
          visibleSignatureComponent.redrawEverything()
        }
      } else {
        this.selectedSignatureProfileImplementation(this.selectedSignatureProfile, null)

        this.$nextTick(() => {
          if (this.$refs.form) {
            this.checkFormValidity()
          }
        })
      }
    },

    showAuthorizationModal() {
      this.authorizationModal = true
      this.$nextTick(() => {
        this.$refs.authorizationModalForm.reset()
        this.$nextTick(() => {
          this.$refs.passwordField.focus()
        })
      })
    },

    async showDeclineModal(e) {
      const opts = {
        title: this.$t('dialog.confirmation.title'),
        posX: e.clientX,
        posY: e.clientY
      }
      const conf = await showConfirmationMenu(opts)
      if (!conf) {
        return
      }
      this.declineReasonVisible = true
    },

    getCurrentProvider() {
      return this.providers.find(
        (provider) => provider.id === this.selectedCredential.provider
      )
    },

    getExternalProviderRDSSBaseURL(providerId) {
      return this.$store.state.remoteConfig.rdssApiUrl + '/v1/extproviders/' + providerId
    },

    handleCSCErrorMessage(error) {
      if (error.message) {
        return this.$t('toastMessage.errorDuringPopupLoginWithDetails', {
          msg: error.message
        })
      } else {
        return this.$t('toastMessage.errorDuringPopupLogin')
      }
    },

    async getCredentialInfosWithCSC() {
      const foundProvider = this.getCurrentProvider()
      const usedOIDC = foundProvider.oidc
      let providerBaseURL

      if (
        usedOIDC.authorizationEndpoint &&
        usedOIDC.tokenEndpoint &&
        usedOIDC.revocationEndpoint
      ) {
        providerBaseURL = this.getExternalProviderRDSSBaseURL(foundProvider.id)
      } else {
        providerBaseURL = foundProvider.apiBaseUrl
      }

      if (!this.selectedCredential.idToken) {
        let oldIdToken = null
        if (foundProvider.id === this.$popupAuth.settings.providerId) {
          const user = await this.$popupAuth.getUser()
          try {
            oldIdToken = user ? await this.$popupAuth.getIdToken() : null
            if (user && !oldIdToken) {
              oldIdToken = await this.$popupAuth.getAccessToken()
            }
          } catch (Err) {
            oldIdToken = null
          }
        }
        if (oldIdToken && foundProvider.id === this.$popupAuth.settings.providerId) {
          this.selectedCredential.idToken = oldIdToken
        } else {
          const settings = {
            authority: usedOIDC.issuer,
            apiBaseUrl: providerBaseURL,
            providerId: foundProvider.id,
            client_id: usedOIDC.clientId,
            response_type: 'code',
            scope: usedOIDC.scope,
            prompt: usedOIDC.prompt,
            monitorSession: false,
            popupWindowFeatures: `location=no,toolbar=no,width=${this.popupLoginWidth},height=${this.popupLoginHeight},left=100,top=100`
          }
          if (usedOIDC.clientSecret) {
            settings.client_secret = usedOIDC.clientSecret
          }

          if (
            usedOIDC.authorizationEndpoint &&
            usedOIDC.tokenEndpoint &&
            usedOIDC.revocationEndpoint
          ) {
            settings.metadata = {
              authorization_endpoint: usedOIDC.authorizationEndpoint,
              // token_endpoint: usedOIDC.tokenEndpoint,
              token_endpoint: providerBaseURL + '/openid/token',
              revocation_endpoint: usedOIDC.revocationEndpoint
            }
          }
          this.$popupAuth.setSettings(settings)
          try {
            const user = await this.$popupAuth.login()
            this.selectedCredential.idToken = user.access_token
            if (!user.id_token) {
              this.selectedCredential.idToken = user.access_token
            } else {
              this.selectedCredential.idToken = user.id_token
            }
          } catch (error) {
            console.error('An error occured during login.', error)
            showToastError(this.handleCSCErrorMessage(error))
            return null
          }
        }
      }

      if (!this.selectedCredential.idToken) {
        showToastError(this.$t('importCredential.loginError'))
        return null
      } else {
        const req = {
          credentialID: this.selectedCredential.credentialId
            ? this.selectedCredential.credentialId
            : this.selectedCredential.id
        }
        try {
          await rssp.joinUserOnRssp()
          const resp = await csc.credentialsInfo(
            providerBaseURL,
            this.selectedCredential.idToken,
            req
          )
          this.$set(this.selectedCredential, 'authMode', resp.authMode.toUpperCase())
          this.$set(this.selectedCredential, 'cert', resp.cert)
          this.$set(this.selectedCredential, 'providerBaseURL', providerBaseURL)
          return resp
        } catch (error) {
          console.error('An error occured during getting credential infos.', error)
          showToastError(this.handleCSCErrorMessage(error))
          return null
        }
      }
    },

    extractDocHashes(jsonArray) {
      return jsonArray.map((item) => item.docHash)
    },

    updateDocHashes(targetObj, docHashes) {
      const chunkSize = Math.ceil(docHashes.length / targetObj.signatures.length)
      for (let i = 0; i < targetObj.signatures.length; i++) {
        const startIdx = i * chunkSize
        targetObj.signatures[i].docHashes = docHashes.slice(
          startIdx,
          startIdx + chunkSize
        )
      }
    },

    async signDoc() {
      const isSealSignMode = this.isSealSignMode

      // console.log('this.selectedCredential', this.selectedCredential)
      const credentialRefId = this.selectedCredential?.provider
        ? this.selectedCredential.id
        : undefined
      const evroRefId = this.selectedCredential?.isEvro
        ? this.selectedCredential.id
        : undefined
      /* console.log('credentialRefId', credentialRefId)
      console.log('evroRefId', evroRefId) */

      if (
        this.selectedCredential &&
        this.selectedCredential.provider &&
        credentialRefId &&
        !this.selectedCredential.idToken
      ) {
        await this.getCredentialInfosWithCSC()
        if (!this.selectedCredential.idToken) {
          console.log('No idToken present, aborting sign')
          return
        }
      }

      if (!isSealSignMode) {
        if (this.selectedCredential) {
          let certChainOK = true

          if (this.selectedCredential && this.selectedCredential.id !== -1) {
            if (
              this.selectedCredential.isEvro &&
              (!this.selectedCredential.certificatePem ||
                this.selectedCredential.certificatePem.length === 0)
            ) {
              certChainOK = false
            }
            if (
              !this.selectedCredential.provider &&
              !this.selectedCredential.isEvro &&
              !this.selectedCredential.isAlfa &&
              (!this.selectedCredential.certChain ||
                this.selectedCredential.certChain.length === 0)
            ) {
              certChainOK = false
            }
            if (
              this.selectedCredential.provider &&
              (!this.selectedCredential.cert ||
                this.selectedCredential.cert.certificates.length === 0)
            ) {
              certChainOK = false
            }
          }

          if (
            this.selectedCredential &&
            !certChainOK &&
            !this.isAlfaTrust
          ) {
            showToastError(
              this.$t(
                'documentSignatureCustomization.content.signature.noCertificateError'
              )
            )
            return
          }

          if (this.useSignatureProfile && this.selectedSignatureProfile) {
            const profileCredFoundInActivated = !!this.activatedCredentials.find(
              (cred) => cred.id === parseInt(this.selectedCredential.id)
            )
            const profileCredFoundInImported = !!this.credentialRefs.find(
              (cred) => cred.id === parseInt(this.selectedCredential.id)
            )
            const profileCredFoundInEvro = !!this.credentialsEvro.find(
              (cred) => cred.id === parseInt(this.selectedCredential.id)
            )
            if (
              !profileCredFoundInActivated &&
              !profileCredFoundInImported &&
              !profileCredFoundInEvro
            ) {
              showToastError(this.$t('validation.form.credentialIsDead'))
              return
            }
          }
        }
      }

      const explicitCredential =
        !isSealSignMode && this.isExplicitCredential
      const implicitCredential =
        !isSealSignMode && this.isImplicitCredential
      const importedCredential = !isSealSignMode && this.selectedCredential.provider

      this.authorizationModalBtnLoading = explicitCredential

      if (implicitCredential && !importedCredential && this.devicesListTotalItems === 0) {
        showToastError(
          this.$t(
            'documentSignatureCustomization.content.signature.activeCredentialButNoActivatedDeviceError'
          )
        )
        return
      }

      if (implicitCredential || evroRefId) {
        this.implicitGuid = uuidv4()
      }

      const OAUTH2CODECredential = this.isOAUTH2CODECredential

      // (elem.certChain.length > 0)))
      try {
        const signRequest = {
          useSeal: isSealSignMode
        }

        if (!isSealSignMode) {
          const credentialOptions = {
            description: this.implicitGuid
          }
          if (credentialRefId) {
            this.$set(credentialOptions, 'credentialRefId', credentialRefId)
            this.$set(
              credentialOptions,
              'authentication',
              this.selectedCredential.idToken
            )
          } else if (evroRefId) {
            this.$set(credentialOptions, 'evroRefId', evroRefId)
          } else if (this.selectedCredential.id) {
            this.$set(credentialOptions, 'credentialId', this.selectedCredential.id)
          }
          if (explicitCredential) {
            this.$set(credentialOptions, 'PIN', this.expAuthPwd.pwd)
          }
          this.$set(signRequest, 'credentialOptions', credentialOptions)
        }

        if (this.pdfEncrypted && this.pdf_password) {
          const documentsOptions = []
          const documentsOption = {
            docId: this.document.id,
            passwordProtection: this.pdf_password
          }
          documentsOptions.push(documentsOption)
          this.$set(signRequest, 'documentsOptions', documentsOptions)
        }

        // console.log('this.chainContainer', this.chainContainer)

        const signaturesArr = []
        const signature = {
          signatureId: this.getUserSignatureId(this.chainContainer),
          currentSignatureId: this.getCurrentSignatureId(this.chainContainer)
          // signatureFieldParameters: this.selectedSignatureProfile.savedSignatureFieldParameters
        }
        signaturesArr.push(signature)
        this.$set(signRequest, 'signatures', signaturesArr)

        if (isSealSignMode && !this.useDifferentCredential) {
          // await this.$refs.visibleSignature.emitSignatureProfileImage()
          if (this.selectedSignatureProfile) {
            this.$set(signRequest, 'signatureProfileId', this.selectedSignatureProfile.id)

            // before siganture, we asking the current preview position (in case the widget is not moved by hand)
            // signRequest = Object.assign({}, signRequest, profileParameters)
          }
        }

        try {
          this.authorizationModalBtnLoading = true

          if (implicitCredential || evroRefId) {
            this.implicitAuthorizationModalKey++
            this.ImplicitAuthorizationModalVisible = true
          }

          let providerAuthorizationTimeoutMilis
          let foundProvider
          if (this.selectedCredential && this.selectedCredential.provider) {
            foundProvider = this.getCurrentProvider()
            providerAuthorizationTimeoutMilis = foundProvider.authorizationTimeoutSecs
              ? foundProvider.authorizationTimeoutSecs * 1000
              : 0
          }
          const usedAuthorizationTimeoutSecs =
            this.selectedCredential && this.selectedCredential.isEvro
              ? this.evroTrustAuthorizationTimeoutMilis
              : this.selectedCredential && this.selectedCredential.provider
                ? providerAuthorizationTimeoutMilis
                : this.authorizationTimeoutMilis
          if (OAUTH2CODECredential) {
            this.$set(signRequest, 'returnHashes', true)
          }

          const sign1Resp = await signatures.sign(
            signRequest,
            implicitCredential || evroRefId ? usedAuthorizationTimeoutSecs : null
          )

          if (OAUTH2CODECredential) {
            let sad
            const docHashes = this.extractDocHashes(sign1Resp)

            if (foundProvider) {
              this.$set(signRequest, 'returnHashes', true)
              const url = window.location.origin
              const settings = {
                authority: foundProvider.oidc.issuer,
                client_id: foundProvider.oidc.clientId,
                popup_redirect_uri: `${url}/popup-callback`,
                response_type: 'code',
                scope: 'credential',
                prompt: foundProvider.oidc.prompt,
                monitorSession: false,
                popupWindowFeatures: {
                  location: false,
                  menubar: false,
                  toolbar: false,
                  height: this.popupLoginHeight,
                  width: this.popupLoginWidth,
                  closePopupWindowAfterInSeconds: -1
                }
              }
              if (foundProvider.oidc.clientSecret) {
                settings.client_secret = foundProvider.oidc.clientSecret
              }
              let providerBaseURL
              if (
                foundProvider.oidc.authorizationEndpoint &&
                foundProvider.oidc.tokenEndpoint &&
                foundProvider.oidc.revocationEndpoint
              ) {
                providerBaseURL = this.getExternalProviderRDSSBaseURL(foundProvider.id)
                settings.metadata = {
                  authorization_endpoint: foundProvider.oidc.authorizationEndpoint,
                  token_endpoint: providerBaseURL + '/openid/token',
                  revocation_endpoint: foundProvider.oidc.revocationEndpoint
                }

                settings.extraQueryParams = {
                  numSignatures: docHashes.length,
                  credentialID: this.selectedCredential.credentialId
                    ? this.selectedCredential.credentialId
                    : this.selectedCredential.id,
                  hash: docHashes,
                  description: 'Please allow RSSP to sign with your key!'
                }
              } else {
                providerBaseURL = foundProvider.apiBaseUrl
              }
              const mgr = new UserManager(settings)
              try {
                const user = await mgr.signinPopup()
                if (user.token_type === 'SAD') {
                  sad = user.access_token
                } else {
                  if (!user.id_token) {
                    this.selectedCredential.idToken = user.access_token
                  } else {
                    this.selectedCredential.idToken = user.id_token
                  }
                  sad = user.sad
                }
              } catch (error) {
                console.error('An error occured during login.', error)
                showToastError(this.handleCSCErrorMessage(error))
                return
              }
            } else {
              const authorizeCredentialRequest = {
                numSignatures: docHashes.length,
                hash: docHashes
              }
              this.$set(
                authorizeCredentialRequest,
                'credentialID',
                this.selectedCredential.credentialId
                  ? this.selectedCredential.credentialId
                  : this.selectedCredential.id
              )
              if (explicitCredential) {
                this.$set(authorizeCredentialRequest, 'PIN', this.expAuthPwd.pwd)
              }

              const authorizeCredentialResp = await csc.authorizeCredential(
                this.selectedCredential.providerBaseURL,
                this.selectedCredential.idToken,
                authorizeCredentialRequest
              )

              sad = authorizeCredentialResp.SAD
            }
            this.$set(signRequest, 'returnHashes', false)
            this.$set(signRequest, 'sad', sad)
            this.updateDocHashes(signRequest, docHashes)

            const sign2Resp = await signatures.sign(
              signRequest,
              implicitCredential ? usedAuthorizationTimeoutSecs : null
            )
          }

          this.back()
          showToastSuccess(this.$t('toastMessage.succesfullySigned'))
        } catch (error) {
          const errorMsg = this.getErrorMessage(error)
          showToastError(errorMsg)
        }
      } catch (error2) {
        console.error('signDoc, exception occured', error2)
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.authorizationModalBtnLoading = false
        this.ImplicitAuthorizationModalVisible = false
        this.authorizationModal = false
      }
    },

    back() {
      this.declineReasonVisible = false
      this.$router.push({ name: 'SignatureChains' })
    },

    checkFormValidity() {
      // Check if the form is valid
      if (this.$refs.form.validate()) {
        this.formValid = true
      } else {
      }
    },

    getUserSignatureId(item) {
      if (!item) {
        // console.log('getUserSignatureId item is null')
        return null
      }
      const userSignature = item.signatures.find(signature => (!!signature.user && signature.user.id === this.currentUser.id && signature.status === SignatureChainStatus.CREATED))
      return userSignature.id
    },

    getCurrentSignatureId(item) {
      if (!item) {
        // console.log('getCurrentSignatureId item is null')
        return null
      }
      if (item.type === SignatureChainType.UNORDERED && !!item.currentSignatureId) {
        return item.currentSignatureId
      } else return undefined
    },

    logValidationErrors() {
      // Check if errorBag exists and is an object
      if (this.$refs.form.errorBag && typeof this.$refs.form.errorBag === 'object') {
        // Iterate through errorBag and log error messages and rules
        for (const fieldName in this.$refs.form.errorBag) {
          const fieldErrors = this.$refs.form.errorBag[fieldName]
          if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach(error => {
              console.error(error)
            })
          } else if (typeof fieldErrors === 'string') {
            console.error(`Field: ${fieldName}, Error Message: ${fieldErrors}`)
          } else {
            // Handle if fieldErrors is not an array or string
            console.error(`Unexpected errorBag structure for field ${fieldName}:`, fieldErrors)
          }
        }
      } else {
        console.error('ErrorBag is not properly defined or is not an object')
      }
    },
    handleFormValidityChange(valid) {
      // valid parameter indicates whether the form is valid or not
      if (!valid) {
        // Additional actions you may want to take when a validation error occurs
        // this.logValidationErrors()
      }
    },
    findCredentialByRefId(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(
        (item) => item.provider && parseInt(item.id) === searchId
      )
      return { ...matchingCredential }
    },
    findCredentialByEvroRefId(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(
        (item) => item.isEvro && parseInt(item.id) === searchId
      )
      return { ...matchingCredential }
    },
    findCredentialById(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(
        (item) => !item.provider && !item.isEvro && parseInt(item.id) === searchId
      )
      return { ...matchingCredential }
    },
    getCredentialItemText(item) {
      if (item.provider) {
        return `${item.description} | external: ${item.provider}`
      } else {
        if (item.isEvro) {
          return `${item.description} | evrotrust`
        } else if (item.isAlfa) {
          return `${item.description} | alfasign`
        } else {
          return item.description
        }
      }
    }
  }
}
</script>

<style>
.BlueWarning {
  color: var(--v-accent-base);
}
</style>
